
import { Component, Vue } from 'nuxt-property-decorator'
import FeaturesBanner, {
  FeaturesBannerItem,
} from '@/components/sections/FeaturesBanner.vue'

@Component({
  components: {
    FeaturesBanner,
  },
})
export default class BlackFridayFeaturesBanner extends Vue {
  private featureBannersStyles = {
    '--features-icon-size': '46px',
    '--features-padding-y': '2.25rem',
  }

  private featuresBannerItems: FeaturesBannerItem[] = [
    {
      icon: require('~/assets/icons/black-friday/icon-radar.svg'),
      title: this.$t('credibilityCards.1.title') as string,
      description: this.$t('credibilityCards.1.description') as string,
    },
    {
      icon: require('~/assets/icons/black-friday/icon-calculator.svg'),
      title: this.$t('credibilityCards.2.title') as string,
      description: this.$t('credibilityCards.2.description') as string,
    },
    {
      icon: require('~/assets/icons/black-friday/icon-timer.svg'),
      title: this.$t('credibilityCards.3.title') as string,
      description: this.$t('credibilityCards.3.description') as string,
    },
    {
      icon: require('~/assets/icons/black-friday/icon-flag.svg'),
      title: this.$t('credibilityCards.4.title') as string,
      description: this.$t('credibilityCards.4.description') as string,
    },
  ]
}
